import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const calculateTimeLeft = () => {
    const now = new Date();
    // Set target date to December 21, 2025 at 15:00 (3:00 PM)
    const targetDate = new Date('2025-12-21T15:00:00');
    const difference = targetDate.getTime() - now.getTime();
    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor(difference / (1000 * 60 * 60) % 24),
      minutes: Math.floor(difference / 1000 / 60 % 60),
      seconds: Math.floor(difference / 1000 % 60)
    };
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex justify-center gap-4" data-id="element-47">
      <div className="bg-white p-4 rounded-lg w-20 shadow-md" data-id="element-48">
        <div className="text-3xl font-bold text-blue-500" data-id="element-49">{timeLeft.days}</div>
        <div className="text-gray-500 text-sm" data-id="element-50">Days</div>
      </div>
      <div className="bg-white p-4 rounded-lg w-20 shadow-md" data-id="element-51">
        <div className="text-3xl font-bold text-blue-500" data-id="element-52">{timeLeft.hours}</div>
        <div className="text-gray-500 text-sm" data-id="element-53">Hours</div>
      </div>
      <div className="bg-white p-4 rounded-lg w-20 shadow-md" data-id="element-54">
        <div className="text-3xl font-bold text-blue-500" data-id="element-55">
          {timeLeft.minutes}
        </div>
        <div className="text-gray-500 text-sm" data-id="element-56">Minutes</div>
      </div>
      <div className="bg-white p-4 rounded-lg w-20 shadow-md" data-id="element-57">
        <div className="text-3xl font-bold text-blue-500" data-id="element-58">
          {timeLeft.seconds}
        </div>
        <div className="text-gray-500 text-sm" data-id="element-59">Seconds</div>
      </div>
    </div>;
}